import { render, staticRenderFns } from "./Strut1000-B.vue?vue&type=template&id=6288eb14"
import script from "./Strut1000-B.vue?vue&type=script&lang=js"
export * from "./Strut1000-B.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports